import clsx from 'clsx';
import i18n from 'i18n';
import _ from 'lodash';
import React from 'react';
import { GlobalScopeVars } from 'types/rest/blazeDataTypes';
import styles from './GlobalScopePreview.module.css';
import BlurredLoader from 'components/overlays/BlurredLoader';
import DownloadBtn from '../Buttons/DownloadBtn';
import { downloadJsonPayloadAsCsv, getErrorMessage } from 'utils/miscUtil';
import { showToastNotification } from 'store/ui/toasts/toastsActions';
import { ToastType } from 'store/ui/toasts/toastsTypes';
import { useDispatch } from 'react-redux';

interface GlobalScopeProps {
  dataCount: number;
  globalScope: GlobalScopeVars;
  refreshBtn: any;
  isExportInProgress: boolean;
  isFixedData: boolean;
}

const GlobalScopePreview = (props: GlobalScopeProps) => {
  const dispatch = useDispatch();

  const getRows = () => {
    return _.map(props.globalScope, (value, key) => {
      return (
        <tr key={key}>
          <td className={clsx(styles.rowItem, 'text-truncate')}>
            <strong title={key}>{key}:</strong>
          </td>
          <td>{value}</td>
        </tr>
      );
    });
  };

  const downloadHandler = () => {
    try {
      const fileName = 'global_scope.json';
      downloadJsonPayloadAsCsv(props.globalScope, fileName);
    } catch (error) {
      dispatch(showToastNotification(ToastType.Danger, 'Unable to download the file', getErrorMessage(error)));
    }
  };

  return (
    <div>
      <div className={'mt-3 mb-3 clearfix'}>
        <h2 className={'font-weight-semi-bold'}>
          {i18n.t('dataSettings:dataModel.msData')} <span className="text-muted">({props.dataCount})</span>
          <div className={'float-right'}>
            {props.isFixedData ? <DownloadBtn onDownload={downloadHandler} /> : undefined}
            {props.refreshBtn ? props.refreshBtn : undefined}
          </div>
        </h2>
      </div>

      <BlurredLoader isLoading={props.isExportInProgress}>
        {props.dataCount === 0 ? (
          <span>There are no Global Scope parameters defined.</span>
        ) : (
          <table className={clsx(styles.table, 'table table-borderless table-hover')}>
            <tbody>{getRows()}</tbody>
          </table>
        )}
      </BlurredLoader>
    </div>
  );
};

export default GlobalScopePreview;
